import groupBy from 'lodash/groupBy';
import { useState } from 'react';
import useRoleState from './useRoleState';
import { MembershipInputV3 } from '../../apollo/queries/v3/createUserV3.queries';

const useAddEditUserRole = () => {
  const [selectedRoles, setSelectedRoles] = useRoleState();
  const [selectedOrgs, setSelectedOrgs] = useState<string[]>([]);

  const getMembershipInputV3 = (): MembershipInputV3[] => {
    const grouped = groupBy(selectedRoles, 'org');
    const memberships: MembershipInputV3[] = [];

    Object.keys(grouped).forEach((key) => {
      if (key !== '') {
        memberships.push({
          organisation: key,
          roles: grouped[key].map((role) => role.id),
        });
      }
    });

    return memberships;
  };

  const isAnyOrgHasEmptyRoles = (orgCode: string): boolean => {
    const memberships = getMembershipInputV3();

    if (orgCode && orgCode !== '') {
      const mem = memberships.find((m) => m.organisation === orgCode);
      return mem ? mem?.roles.length === 0 : true;
    }

    if (selectedOrgs.length === memberships.length) {
      const isExist = (m: MembershipInputV3) =>
        selectedOrgs.includes(m.organisation) && m.roles.length === 0;

      return memberships.some(isExist);
    }

    return true;
  };

  return {
    selectedRoles,
    setSelectedRoles,
    setSelectedOrgs,
    getMembershipInputV3,
    isAnyOrgHasEmptyRoles,
  };
};

export default useAddEditUserRole;
